import gql from 'graphql-tag'

export default gql`
	query sendDatev(
		$shopId: [ID]!
		$email: String!
		$datePeriod: FullDateTimeIntervalInput!
	) {
		cashAssist {
			sendDatev(shopId: $shopId, email: $email, datePeriod: $datePeriod) {
				success
				messages
				error
			}
		}
	}

`
